// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__2ZeMe","textHolder":"Divider_textHolder__2D-V3"};